import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { MessageService } from '@openng/optimus-ui/api';
import { errorPopup, fetchCurrentSponsor, messagePopup, setCurrentSponsor, successPopup, warningPopup } from '../actions/ui.actions';
import { TranslateService } from '@ngx-translate/core';
import { SponsorService } from '../../core/services/sponsor.service';

@Injectable()
export class UIEffects {
  private actions = inject(Actions);
  private messageService = inject(MessageService);
  private translationService = inject(TranslateService);
  private sponsorService = inject(SponsorService);
  private readonly messageLifeTime = 3000;

  fetchCurrentSponsor = createEffect(() => {
    return this.actions.pipe(
      ofType(fetchCurrentSponsor),
      mergeMap(() =>
        this.sponsorService.getCurrentSponsor().pipe(
          mergeMap(sponsor => [setCurrentSponsor({ sponsor })]),
          catchError(() => []),
        ),
      ),
    );
  });

  showToastInfoMessage = createEffect(
    () => {
      return this.actions.pipe(
        ofType(messagePopup),
        tap(({ message }) => {
          this.messageService.add({
            severity: 'info',
            detail: this.translationService.instant(message),
            life: this.messageLifeTime,
          });
        }),
      );
    },
    { dispatch: false },
  );

  showToastErrorMessage = createEffect(
    () => {
      return this.actions.pipe(
        ofType(errorPopup),
        tap(({ error }) => {
          this.messageService.add({
            severity: 'error',
            detail: this.translationService.instant(error),
            life: this.messageLifeTime,
          });
        }),
      );
    },
    { dispatch: false },
  );

  showToastSuccessMessage = createEffect(
    () => {
      return this.actions.pipe(
        ofType(successPopup),
        tap(({ message }) => {
          this.messageService.add({
            severity: 'success',
            detail: this.translationService.instant(message),
            life: this.messageLifeTime,
          });
        }),
      );
    },
    { dispatch: false },
  );

  showToastWarningMessage = createEffect(
    () => {
      return this.actions.pipe(
        ofType(warningPopup),
        tap(({ message }) => {
          this.messageService.add({
            severity: 'warn',
            detail: this.translationService.instant(message),
            life: this.messageLifeTime,
          });
        }),
      );
    },
    { dispatch: false },
  );
}
